export default {
  user: {
    Name: '姓名',
    UnitName: '单位名称',
    UnitId: '单位ID',
    WechatNo: '微信号',
    UserType: '用户类型',
    EffectiveTime: '有效时间',
    BeginDay: '有效日期开始',
    EndDay: '有效日期结束',
    OrgName: '组织名称',
    OrgId: '组织Id',
    RelationRule: '关联角色',
    RuleCode: '角色编码',
    RuleName: '角色名称',
    ChooseUnit: '单位选择',
    OnlineRegister: '网上注册',
    Custom: '自定义',
    SystemRetention: '系统保留',
    UserNameCanNotBeEmpty: '用户名称不能为空',
    UserCodeCanNotBeEmpty: '用户编号不能为空',
    EffectiveTimeCanNotBeEmpty: '有效日期不能为空',
    PleaseEnterNum: '请输入数字',
    MobileCanNotBeEmpty: '手机号不能为空',
    PleaseEnterCorrectMobile: '请输入正确的电话号码',
    SystemCanNotBeEmpty: '系统不能为空',
    BirthdayCanNotBeEmpty: '生日日期不能为空',
    ProvinceCanNotBeEmpty: '省份不能为空',
    CityCanNotBeEmpty: '城市不能为空',
    AreaCanNotBeEmpty: '地区不能为空',
    LoginNameCanNotBeEmpty: '账号不能为空',
    PasswordCanNotBeEmpty: '密码不能为空',
    WechatNumberCanNotBeEmpty: '微信号不能为空'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/user.js